var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowSmallDown2 = function SvgArrowSmallDown2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.60558 12.1517C9.85107 12.3519 10.2133 12.3374 10.4422 12.1085L13.7755 8.77521C14.0196 8.53113 14.0196 8.1355 13.7755 7.89142C13.5314 7.64735 13.1358 7.64735 12.8917 7.89142L10.0003 10.7829L7.10884 7.89142C6.86476 7.64735 6.46913 7.64735 6.22505 7.89142C5.98097 8.1355 5.98097 8.53113 6.22505 8.77521L9.55838 12.1085L9.60558 12.1517Z",
    fill: "currentColor"
  })));
};
export default SvgArrowSmallDown2;